import { Dispatch } from 'redux';
import { showFeedback } from '../../feedback/feedbackReducer';
import { webhookRequestApi } from '../../apis';

export const retryRequest = (webhookRequestId: number) => async (dispatch: Dispatch) => {
  try {
    const retriedRequest = await webhookRequestApi.retryWebhookRequest({
      webhookRequestId,
    });
    dispatch(
      showFeedback({
        message: `Request #${webhookRequestId} rescheduled!`,
        success: true,
      })
    );
    return retriedRequest;
  } catch (e) {
    dispatch(
      showFeedback({
        message: `Failed to reschedule request #${webhookRequestId}!`,
        success: false,
      })
    );
    throw e;
  }
};
